import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import { Button, Divider, Popover, Progress, Tooltip } from 'antd';
import { useLocation, useNavigate } from "react-router-dom";
import styles from './loginHead.module.scss'
import SwitchHomePageType from '../SwitchHomePageType';
import * as PromoteButtons from '../PromoteButtons';
import PayModal from '@view/compoents/payModal/payModal'
import Utils from '@utils/utils'

function LoggedHead(props) {
    const location = useLocation();

    const handleClick = (e) => {
        e.preventDefault()
        e.stopPropagation()
        props.onLogin()
    }

    const payChildRef = useRef(null);
    const openPayClick = () => {
        if (localStorage.getItem('channel') == 'taobao') return
        payChildRef.current.openrechargeClick()
    }

    return (
        <div className={styles.LoginHead}>
            <i></i>
            <div style={{ display: 'flex', gap: ".24rem" }}>
                <PromoteButtons.ServiceBtn />
                <PromoteButtons.NewUserBtn />
                {localStorage.getItem('channel') != 'taobao' && <PromoteButtons.MembershipBtn onClick={openPayClick} />}
                <img className={styles.btn_r} onClick={handleClick} src={require('@assets/images/icon_Avatar.png')} alt="" />
            </div>
            <PayModal ref={payChildRef}></PayModal>
        </div>

    )
}

export default LoggedHead